var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.item && _vm.item.visible_for_conductor)?_c('div',{staticClass:"mb-6"},[_c('h2',[_vm._v(" "+_vm._s(_vm.$t('template-builder.add-hide-action.text'))+" ")]),(_vm.isShowingErrors)?_c('div',{staticClass:"error-text mt-2 text-red"},[_vm._v(_vm._s(_vm.$t('issues.action-required')))]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }